import { HttpHelper, HttpServiceParams } from '@ppvrbh/merchant-frontend-core';
import { envConfig } from '../../../../../config';
import { INVITATION_REQUEST_ID_LIST } from './invitation-constant';

class InvitationServiceClass {
  postInvitationRegistration = async (params: HttpServiceParams) => {
    return await HttpHelper.post({
      url: `${envConfig.hostname}v1/merchant/company-admin/merchant-gp-acceptance`,
      data: params.data,
      id: INVITATION_REQUEST_ID_LIST.POST_INVITATION_REGISTRATION
    });
  }
  
  getTncStatus = async (params: HttpServiceParams) => {
    const searchParams = new URLSearchParams();
    const {token, channel, campaignName} = params.data;
    
    if (token) {
      searchParams.append('token', token)
    }
    if (channel) {
      searchParams.append('channel', channel)
    }

    if (campaignName) {
      searchParams.append('campaignName', campaignName)
    }

    let query = searchParams.toString();
    if (query) {
      query = '?' + query;
    }
  
    return await HttpHelper.get({
      url: `${envConfig.hostname}v1/merchant/company-admin/merchant-gp-acceptance` + query,
      id: INVITATION_REQUEST_ID_LIST.GET_TNC_CONFIG
    });
  }

  getTncDetail = async (params: HttpServiceParams) => {
    return await HttpHelper.get({
      url: params.data.url,
      id: INVITATION_REQUEST_ID_LIST.GET_TNC_DETAIL
    });
  }

  getGeneralConfigs = async () => {
    return await HttpHelper.get({
      url: `${envConfig.hostname}v1/merchant/master/general-configs`,
      id: INVITATION_REQUEST_ID_LIST.GET_GENERAL_CONFIG
    });
  }
}

export const InvitationService = new InvitationServiceClass();
